const REMEMBERED_USERNAME_KEY = "procurement.rememberedUsername";
const PASSWORD_UPDATED_KEY = "procurement.passwordJustUpdated";
const PASSWORD_CHANGED_AT_KEY = "procurement.passwordChangedAt";

export const getRememberedUsername = () => {
  try {
    return localStorage.getItem(REMEMBERED_USERNAME_KEY) || "";
  } catch {
    return "";
  }
};

export const setRememberedUsername = (username) => {
  try {
    const value = String(username || "").trim();
    if (value) localStorage.setItem(REMEMBERED_USERNAME_KEY, value);
    else localStorage.removeItem(REMEMBERED_USERNAME_KEY);
  } catch {
    // ignore quota / private mode
  }
};

export const markPasswordUpdated = (username) => {
  try {
    localStorage.setItem(PASSWORD_UPDATED_KEY, String(username || "").trim() || "1");
  } catch {
    // ignore
  }
};

export const getPasswordUpdatedUsername = () => {
  try {
    const value = localStorage.getItem(PASSWORD_UPDATED_KEY);
    if (!value || value === "1") return "";
    return value;
  } catch {
    return "";
  }
};

export const wasPasswordJustUpdated = () => {
  try {
    return Boolean(localStorage.getItem(PASSWORD_UPDATED_KEY));
  } catch {
    return false;
  }
};

export const clearPasswordUpdated = () => {
  try {
    localStorage.removeItem(PASSWORD_UPDATED_KEY);
  } catch {
    // ignore
  }
};

export const rememberPasswordChangedAt = (value) => {
  try {
    localStorage.setItem(
      PASSWORD_CHANGED_AT_KEY,
      value || new Date().toISOString()
    );
  } catch {
    // ignore
  }
};

export const getLocalPasswordChangedAt = () => {
  try {
    return localStorage.getItem(PASSWORD_CHANGED_AT_KEY) || "";
  } catch {
    return "";
  }
};
